import React from 'react';
import { Icon } from '@iconify/react';

interface HoverPlayButtonProps {
  icon: string;
  className?: string;
}

const HoverPlayButton: React.FC<HoverPlayButtonProps> = ({
  icon,
  className = ''
}) => {
  return (
    <div className={`absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/60 opacity-0 group-hover:opacity-100 transition-all duration-300 ${className}`}>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="w-14 h-14 rounded-full bg-white/30 backdrop-blur-md flex items-center justify-center transform transition-all duration-300 group-hover:scale-110 border border-white/30 shadow-xl">
          <Icon icon={icon} className="w-7 h-7 text-white" />
        </div>
      </div>
    </div>
  );
};

export default HoverPlayButton; 